// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container_3B8tg","center":"Card_center_3IGMX"};